import axiosInstance from 'api/axiosInstance';
import { Checklist } from './getActivityReport';

export interface PatrolDetailsResponse {
  ScheduleAssignmentId: number;
  Checklists: Checklist[];
  GeneralComment: string | null;
}

export const getPatrolDetails = async (
  scheduleAssignmentId: number
): Promise<PatrolDetailsResponse> => {
  try {
    const response = await axiosInstance.get(
      '/api/activityreportcontroller/GetPatrolDetails',
      {
        params: { scheduleAssignmentId },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error fetching patrol details:', error);
    throw error;
  }
};

export default getPatrolDetails;
